import apiClient, { apiClientV2 } from "../common";

export const ApiCoverageList = async (
  chronology: string = "year_month",
  simulationId?: string | null,
) => {
  const strip =
    chronology === "year_month_week" ? "&strip_forecast" : "";
  if (simulationId) {
    return await apiClientV2.get(
      `coverage_simulator/products/coverage/list/${simulationId}/?chronology=${chronology}${strip}`,
      { withCredentials: true },
    );
  }
  return await apiClient.get(
    "coverage_simulator/products/coverage/list/?chronology=" +
      chronology +
      strip,
    { withCredentials: true },
  );
};

export const ApiCoverageDownload = async (time_unit: string = "year_month") => {
  return await apiClient.get(
    "coverage_simulator/products/coverage/download/?time_unit=" + time_unit,
    { withCredentials: true, responseType: "blob" },
  );
};

/** Persiste motivo de desviación (API v2). */
export const ApiCoverageDeviationReasonPatch = async (
  productId: number,
  coverage_deviation_reason: string,
) => {
  return await apiClientV2.patch(
    `coverage_simulator/products/${productId}/coverage-deviation-reason/`,
    { coverage_deviation_reason },
    { withCredentials: true },
  );
};

